<template>
  <div class="task_pop_bg">
    <!-- 标题 -->
    <div class="topSpot"></div>
    <div class="bottomSpot"></div>
    <div class="topBorder"></div>
    <div class="titleLine">
      <div class="info_title">
        <div class="titleLine_name">
          <span class="leftLine"></span
          ><span style="color: #2ac1ff">消息详情</span>
        </div>
        <div class="closeBtn" @click="closeMsgDetail"></div>
      </div>
    </div>
    <div class="middleOutLine" id="msgContent">
      <el-form :model="form" :rules="rules">
        <div class="messageRow notisfy">
          <div class="circleType">{{ form.entityTypeTranslated }}预警</div>
          <div
            class="margin_0_10"
            :class="{
              redLevel: form.AlerteLevel === 10,
              orangeLevel: form.AlerteLevel === 7,
              yellowLevel: form.AlerteLevel === 5,
              blueLevel: form.AlerteLevel === 3,
            }"
          >
            {{ form.entityTypeTranslated }}{{ form.warnTypeTranslated }}
          </div>
          <div class="margin_left">
            {{ form.statusTranslated }}
          </div>
        </div>
        <div class="notisfy">
          <span style="margin-right: 20px">时间：{{ form.createTime }} </span
          ><span style="margin-right: 20px"
            >来源：{{ form.sourceTypeTranslated }}
          </span>
          等级：{{ form.processLevelTranslated }}
        </div>
        <div class="notisfy">详情</div>
        <div class="notisfy" style="margin-left: 7%">
          {{ form.messageIntro }}
        </div>
        <el-form-item v-if="reportList.length > 0">
          <!-- :disabled="!IsEdit" :on-remove="handleRemove"-->
          <el-upload
            action="#"
            list-type="picture-card"
            :file-list="reportList"
            :disabled="true"
            :on-preview="handleReportPreview"
          >
          </el-upload>
          <el-dialog :visible.sync="dialogReportVisible">
            <div style="margin-top: 30px">
              <img width="100%" :src="dialogImgReportUrl" alt="" />
            </div>
          </el-dialog>
        </el-form-item>
        <div class="mapBox">
          <!--  ref="map-mapview" -->
          <div class="covermap">
            <div
              class="map"
              id="allmapIndex"
              style="width: 100%; height: 100%; z-index: 2 !important"
            ></div>
          </div>

          <div class="coverbg"></div>
        </div>
        <div v-if="form.status == '1'">
          <div class="notisfy">
            <span style="margin-right: 20px"
              >处理人：{{ form.processUser }} </span
            ><span style="margin-right: 20px"
              >处理时间：{{ form.processTime }}
            </span>
          </div>
          <div class="notisfy">处理结果：</div>
          <div class="notisfy" style="margin-left: 7%">
            {{ form.processResult }}
          </div>
          <div class="notisfy" v-if="form.taskId">关联任务：</div>
          <div class="notisfy task" style="margin-left: 7%" v-if="form.taskId">
            <span @click="queryTask()">{{ taskTitle }}</span>
          </div>

          <el-form-item v-if="fileList.length > 0">
            <!-- :disabled="!IsEdit" :on-remove="handleRemove"-->
            <el-upload
              action="#"
              list-type="picture-card"
              :file-list="fileList"
              :disabled="true"
              :on-preview="handlePictureCardPreview"
            >
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <div style="margin-top: 30px">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </div>
            </el-dialog>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="msgfooter" v-if="form.status != '1'">
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item
          style="margin-top: 10px; display: flex; justify-content: flex-end"
        >
          <el-button @click="handleManual()" style="margin-left: 15px"
            >人工处理</el-button
          >
          <el-button @click="handleTask()" style="margin-left: 15px"
            >转任务</el-button
          >
          <!-- <el-button @click="handleEmergency()" style="margin-left: 15px"
            >转应急</el-button
          > -->
        </el-form-item>
      </el-form>
    </div>
    <div class="bottomBorder"></div>
    <MsgManual
      v-if="isShowManual"
      :isShow="isShowManual"
      :msgInfo="form"
      @closeMsgManual="closeMsgManual"
    ></MsgManual>
    <el-dialog
      class="emergencyoperations-dialog normal"
      custom-class="bg3"
      top="6vh"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isShowTask"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :modal="false"
      v-if="isShowTask"
    >
      <NewTask
        @handlerclose="isShowTask = false"
        :messageDetail="form"
        @closeTask="closeMsgDetail"
      />
    </el-dialog>
    <taskDetails
      v-if="showDetail"
      @closeTaskDetail="closeTaskDetail"
      v-bind:TaskId="taskId"
      v-bind:isLookDetails="showDetail"
    ></taskDetails>
  </div>
</template>
<script>
import { getMessageById } from "@/api/src/message";
import MsgManual from "./MsgManual";
import NewTask from "./Component-NewTask-Home";
import { getIntegratedTaskById } from "@/api/src/integratedTask";
import taskDetails from "./taskDetails";
export default {
  components: {
    MsgManual,
    NewTask,
    taskDetails,
  },
  data() {
    return {
      form: {},
      center: [],
      isShowManual: false,
      isShowTask: false,
      fileList: [],
      reportList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      taskTitle: "",
      dialogImgReportUrl: "",
      dialogReportVisible: false,
      taskId: "",
      showDetail: false,
    };
  },
  props: {
    msgId: {
      type: String,
      default: "",
    },
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  created: function () {
    if (this.isShow && this.msgId) {
      this.getDetails();
    }
  },
  methods: {
    getDetails() {
      this.center = [];

      const that = this;
      that.fileList = [];
      getMessageById(this.msgId).then((res) => {
        this.form = res.data;
        if(res.data.coordinate){
          let coordinate = JSON.parse(res.data.coordinate)
          this.init(() =>{
            this.onDrawMap('',coordinate)
          })
        }else{
          if (res.data.longitude && res.data.latitude) {
            this.center.push(res.data.longitude);
            this.center.push(res.data.latitude);
          }
          this.init(() =>{
            this.onDrawMap(this.center)
          })
        }
        if (res.data?.uploadResouse) {
          let fileList = res.data.uploadResouse.split(",");
          fileList.forEach((item) => {
            let obj = {
              url: item,
            };
            that.fileList.push(obj);
          });
        }
        if (res.data?.reportResouse) {
          let reportFileList = res.data.reportResouse.split(",");
          reportFileList.forEach((item) => {
            let obj = {
              url: item,
            };
            that.reportList.push(obj);
          });
        }

        //如果关联任务的话，获取任务
        if (res.data.taskId) {
          this.taskId = res.data.taskId;
          this.getTask(res.data.taskId);
        }
      });
    },
    getTask(taskId) {
      let that = this;

      getIntegratedTaskById(taskId).then((response) => {
        this.taskTitle = response.data.title;
      });
    },
    closeMsgDetail() {
      this.$emit("closeMsgDetail", false);
    },
    // onDrawMap: function (address) {
    //   // let center = this.center;
    //   this.$nextTick(function(){
    //     let center = this.center;
    //     var map = new BMap.Map("allmapIndex");
    //     var point = new BMap.Point(center[0], center[1]);
    //     map.centerAndZoom(point, 12);
    //     var opts = { type: BMAP_NAVIGATION_CONTROL_SMALL };
    //     map.addControl(new BMap.NavigationControl(opts));
    //     var marker = new BMap.Marker(point); // 创建标注
  
    //     marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
    //     let labelString = "暂无法获取位置";
    //     if (address || this.center.length > 0) {
    //       labelString =
    //         (address || "") + "(" + this.center[0] + "," + this.center[1] + ")";
    //     }
  
    //     var label = new BMap.Label(labelString, {
    //       offset: new BMap.Size(20, -10),
    //     });
    //     marker.setLabel(label);
    //     map.addOverlay(marker); // 将标注添加到地图中
    //   })
    // },
      init(fun){
      let that = this;
      var mapConfigs = {};
      this.$nextTick(function () {
        // eslint-disable-next-line no-undef
        $(function () {
          // 不传入 syscode 和 key ，或者值为空时，
          // zjumap 插件自动从 URL 地址
          // http://HOST:PORT/Areas/Map/Content/UMap.html?syscode=xxx&key=yyy
          // 中读取 syscode 和 key 的值。
          // eslint-disable-next-line no-undef
          $(".map").zjumap({
            syscode: "ZJMap",
            key: "DefaultMap",
            loading: ".global-loading",
            loadingText: ".global-loading-text",
            //地图配置
            // eslint-disable-next-line no-undef
            mapConfigs: $.extend(
              {},
              {
                mapStyle: "",
                togglePanelVisiable: false,
                mapLayers: "",
                reportGeo: true,
                // onGotGeo: function (e) {
                //   e.handled = true;
                //   // if (that.marker) {
                //   //   that.marker.setPosition(
                //   //     e.map.newPoint(e.point.lng, e.point.lat)
                //   //   );
                //   // } else {
                //     //that.marker = that.addMarker(e.map, e.point);
                //   // }
                // },
                // onAreaDrawn: function (e) {
                //   that.onAreaDrawn(e.data.points);
                // },
                // onPolygonEditorComplete: function (e) {
                //   that.onAreaDrawn(e.data);
                // },
                onMapCreated: function (e) {
                  that.mapInstance = e.map;
                  e.map.clearAll();
                  // that.center = e.map.config.center;
                  fun()
                },
              },
              mapConfigs
            ),
          });
        });
      });
    },
    onDrawMap(center,coordinate){
        var map = this.mapInstance
        if(center){
          var point = new BMap.Point(center[0] || 0, center[1] || 0);
          map.centerAndZoom(point, 12);
          var marker = new BMap.Marker(point); // 创建标注
          marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
          let labelString = "暂无法获取位置";
          if (center.length > 0) {
            labelString ="(" + center[0] + "," + center[1] + ")";
          }

          var label = new BMap.Label(labelString, {
            offset: new BMap.Size(20, -10),
          });
          marker.setLabel(label);
          map.addOverlay(marker); // 将标注添加到地图中
          map.setViewport([point]);
        }else{
          var point = new BMap.Point(coordinate[0].Longitude, coordinate[1].Latitude);
          map.centerAndZoom(point, 12);
          let pointArr = []
          coordinate.map(item =>{
            pointArr.push(new BMap.Point(item.Longitude, item.Latitude))
          })
          map.drawPolygon(pointArr, 1)
          map.setViewport(pointArr);
        }
    },
    //人工处理消息
    handleManual() {
      this.isShowManual = true;
    },
    closeMsgManual() {
      this.isShowManual = false;
      this.getDetails();
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleReportPreview(file) {
      this.dialogImgReportUrl = file.url;
      this.dialogReportVisible = true;
    },
    //转任务
    handleTask() {
      this.isShowTask = true;
    },
    //转应急
    handleEmergency() {
      this.$confirm("确认转为应急事件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let path = `/plugin/Emergency/UI/NewEvent?MsgId=${this.form.id}`;
        this.$router.push(path);
      });
    },
    //查看任务详情
    queryTask() {
      this.showDetail = true;
    },
    closeTaskDetail() {
      this.showDetail = false;
    },
  },
};
</script>
<style scoped lang="scss">
.task_pop_bg {
  width: 36.5%;
  position: fixed;
  left: 50%;
  top: 120px;
  z-index: 99999;
  margin-left: -18.2%;
  box-sizing: border-box;
  border-bottom-left-radius: 22px;
  .topBorder {
    width: 100%;
    height: 34px;
    background: url("../../../../../../assets/pop_tz.png") no-repeat;
    background-size: 100% 34px;
    position: relative;
  }
  .bottomBorder {
    width: 100%;
    height: 25px;
    background: url("../../../../../../assets/pop_bz.png") no-repeat;
    background-size: 100%;
  }
  .titleLine {
    width: 100%;
    box-sizing: border-box;
    background: rgba(15, 36, 69, 0.8);
    border-left: 1px solid #2ac1ff;
    border-right: 1px solid #2ac1ff;
    padding-bottom: 10px;
    position: relative;
    .info_title {
      width: 92%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px dashed #2ac1ff;
      padding-bottom: 10px;
    }
    .titleLine_name {
      display: flex;
      align-items: center;
      .leftLine {
        display: inline-block;
        width: 2px;
        height: 15px;
        margin-right: 10px;
        background: #2ac1ff;
      }
    }
    .closeBtn {
      width: 20px;
      height: 20px;
      background: url("../../../theme-default/src/img/close.png") no-repeat;
      background-size: 20px;
      position: absolute;
      right: 20px;
      top: 0px;
      cursor: pointer;
      z-index: 10;
    }
  }
  .middleOutLine {
    height: 30.8rem;
    overflow: auto;
    width: 100%;
    padding: 0 10px;
    border-left: 0.5px solid #2ac1ff;
    border-right: 0.5px solid #2ac1ff;
    background: rgba(15, 36, 69, 0.8);
  }
  .notisfy {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 3%;
    font-size: 12px;
    margin-bottom: 15px;
  }
  .task span {
    cursor: pointer;
    color: #29bfff;
  }
  .mapBox {
    width: 100%;
    height: 274px;
    padding: 24px 20px 16px 26px;
    box-sizing: border-box;
    position: relative;
  }
  .coverbg {
    // width: 525px;
    width: 100%;
    height: 274px;
    background: url("../../../../../../assets/mapborder.png") no-repeat;
    background-size: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
  }
  .topSpot {
    width: 222px;
    height: 125px;
    background: url("../../../../../../assets/spot.png") no-repeat;
    position: absolute;
    right: 15px;
    top: -62px;
    z-index: 1;
  }
  .bottomSpot {
    width: 222px;
    height: 120px;
    background: url("../../../../../../assets/spot.png") no-repeat;
    position: absolute;
    left: -35px;
    bottom: -45px;
    z-index: 10000;
  }
  .redLevel {
    color: #fb4d4e;
  }
  .yellowLevel {
    color: #fbda4e;
  }
  .blueLevel {
    color: #2ac1ff;
  }

  .circleType {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    font-size: 20px;
    color: #fff;
    line-height: 50px;
    text-align: center;
    background: #29bfff;
    overflow: hidden;
  }
  .messageRow {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .margin_0_10 {
    margin: 0 10px;
  }
  .margin_left {
    margin-left: 10rem;
  }
  .covermap {
    position: absolute;
    top: 37px;
    left: 50%;
    width: 86%;
    height: 77%;
    z-index: 2;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .msgfooter {
    height: 55px;
    width: 100%;
    padding: 10px 20px;
    border-left: 0.5px solid #2ac1ff;
    border-right: 0.5px solid #2ac1ff;
    background: rgba(15, 36, 69, 0.8);
    position: relative;
    z-index: 20;
  }
}
</style>
